// @ts-nocheck
/* eslint-disable */
// 兼容 shim：确保 window.icons / window.UtilsModule / window.i18nModule 等已就绪
// 后续会逐步迁移到显式 import
import * as React from 'react';
import {
  Badge,
  ActionButton,
  Card,
  Divider,
  Empty,
  Form,
  Input,
  List,
  Modal,
  Select,
  Space,
  Table,
  Tabs,
  Tag,
  Tooltip,
  Typography,
  message,
} from '@ui';
import '@lib/api';
import '@lib/auth';
import '@lib/brand';
import '@lib/utils';
import '@lib/i18n';
import '@ui';
const { icons } = window as any;

/**
 * MessageCenter Component
 * 用户端 - 站内消息中心组件
 *
 * 功能：
 * - 反馈消息/系统消息 Tab 切换
 * - 消息列表（支持状态过滤、批量已读/关闭）
 * - 消息详情（含回复列表 + 回复输入框）
 * - 发送新消息
 * - 未读角标
 */

('use strict');

const { useState, useEffect, useRef } = React;

const {
  MessageOutlined,
  SendOutlined,
  PaperClipOutlined,
  InboxOutlined,
  CloseCircleOutlined,
  CheckOutlined,
  ReloadOutlined,
} = window.icons;
const { TextArea } = Input;
const { Text } = Typography;
const API_BASE = window.API_BASE;
const t = (key, params) => (window.i18nModule ? window.i18nModule.t(key, params) : key);

const formatTime = (timeStr) => {
  if (!timeStr) return '-';
  const d = new Date(timeStr);
  const now = new Date();
  const diff = now - d;
  if (diff < 60000) return t('messages.justNow') || '刚刚';
  if (diff < 3600000)
    return (
      Math.floor(diff / 60000) + (t('metrics.minutes') || '分钟') + (t('messages.ago') || '前')
    );
  if (diff < 86400000)
    return (
      Math.floor(diff / 3600000) + (t('metrics.hours') || '小时') + (t('messages.ago') || '前')
    );
  return (
    d.toLocaleDateString('zh-CN') +
    ' ' +
    d.toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit' })
  );
};

function MessageCenter() {
  const [activeTab, setActiveTab] = useState('feedback');
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [statusFilter, setStatusFilter] = useState('');
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [detailVisible, setDetailVisible] = useState(false);
  const [currentDetail, setCurrentDetail] = useState(null);
  const [detailLoading, setDetailLoading] = useState(false);
  const [sendVisible, setSendVisible] = useState(false);
  const [sendLoading, setSendLoading] = useState(false);
  const [replyContent, setReplyContent] = useState('');
  const [replyLoading, setReplyLoading] = useState(false);
  const [unreadCount, setUnreadCount] = useState({
    feedback_count: 0,
    system_count: 0,
    total_count: 0,
  });
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [replyFiles, setReplyFiles] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [sendForm] = Form.useForm();

  useEffect(() => {
    loadMessages(1, pageSize, activeTab, statusFilter);
    loadUnreadCount();
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    setSelectedRowKeys([]);
    loadMessages(1, pageSize, activeTab, statusFilter);
  }, [activeTab, statusFilter]);

  const loadMessages = async (page, size, type, status) => {
    setLoading(true);
    try {
      let url = `${API_BASE}/messages?page=${page}&page_size=${size}&type=${type}`;
      if (status) url += `&status=${status}`;
      const { response, data, unauthorized } = await window.apiRequest(url);
      if (unauthorized) return;
      if (response.ok) {
        setMessages(data.messages || []);
        setTotal(data.total || 0);
        setCurrentPage(page);
        setPageSize(size);
      } else {
        message.error(data.error || t('messages.listFailed'));
      }
    } catch (error) {
      message.error(t('messages.networkError') + ': ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const loadUnreadCount = async () => {
    try {
      const { response, data } = await window.apiRequest(`${API_BASE}/messages/unread-count`);
      if (response.ok) setUnreadCount(data);
    } catch (e) {}
  };

  const openDetail = async (record) => {
    setDetailVisible(true);
    setDetailLoading(true);
    setReplyContent('');
    setReplyFiles([]);
    try {
      const { response, data } = await window.apiRequest(`${API_BASE}/messages/${record.id}`);
      if (response.ok) {
        setCurrentDetail(data);
        loadMessages(currentPage, pageSize, activeTab, statusFilter);
        loadUnreadCount();
      } else {
        message.error(data.error || t('messages.detailFailed'));
      }
    } catch (error) {
      message.error(t('messages.networkError'));
    } finally {
      setDetailLoading(false);
    }
  };

  const handleSendMessage = async (values) => {
    setSendLoading(true);
    try {
      const body = {
        title: values.title,
        content: values.content,
        attachments: uploadedFiles.map((f) => f.id),
      };
      const { response, data } = await window.apiRequest(`${API_BASE}/messages/send`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      if (response.ok) {
        message.success(t('messages.sendSuccess'));
        setSendVisible(false);
        sendForm.resetFields();
        setUploadedFiles([]);
        loadMessages(1, pageSize, activeTab, statusFilter);
        loadUnreadCount();
      } else {
        message.error(data.error || t('messages.sendFailed'));
      }
    } catch (error) {
      message.error(t('messages.networkError'));
    } finally {
      setSendLoading(false);
    }
  };

  const handleReply = async () => {
    if (!replyContent.trim()) {
      message.warning(t('messages.replyEmpty'));
      return;
    }
    setReplyLoading(true);
    try {
      const body = {
        content: replyContent,
        attachments: replyFiles.map((f) => f.id),
      };
      const { response, data } = await window.apiRequest(
        `${API_BASE}/messages/${currentDetail.id}/replies`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        },
      );
      if (response.ok) {
        message.success(t('messages.replySuccess'));
        setReplyContent('');
        setReplyFiles([]);
        openDetail({ id: currentDetail.id });
      } else {
        message.error(data.error || t('messages.replyFailed'));
      }
    } catch (error) {
      message.error(t('messages.networkError'));
    } finally {
      setReplyLoading(false);
    }
  };

  const handleBatchRead = async () => {
    if (selectedRowKeys.length === 0) return;
    try {
      const { response, data } = await window.apiRequest(`${API_BASE}/messages/batch/read`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message_ids: selectedRowKeys }),
      });
      if (response.ok) {
        message.success(t('messages.batchReadSuccess'));
        setSelectedRowKeys([]);
        loadMessages(currentPage, pageSize, activeTab, statusFilter);
        loadUnreadCount();
      } else {
        message.error(data.error || t('messages.operationFailed'));
      }
    } catch (error) {
      message.error(t('messages.networkError'));
    }
  };

  const handleBatchClose = async () => {
    if (selectedRowKeys.length === 0) return;
    Modal.confirm({
      title: t('common.confirm'),
      content: t('messages.batchCloseConfirm', { count: selectedRowKeys.length }),
      onOk: async () => {
        try {
          const { response, data } = await window.apiRequest(`${API_BASE}/messages/batch/close`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ message_ids: selectedRowKeys }),
          });
          if (response.ok) {
            message.success(t('messages.batchCloseSuccess'));
            setSelectedRowKeys([]);
            loadMessages(currentPage, pageSize, activeTab, statusFilter);
            loadUnreadCount();
          } else {
            message.error(data.error || t('messages.operationFailed'));
          }
        } catch (error) {
          message.error(t('messages.networkError'));
        }
      },
    });
  };

  const handleUpload = async (file, fileList, setFileList) => {
    if (fileList.length >= 2) {
      message.warning(t('messages.attachmentLimit', { max: 2 }));
      return false;
    }
    if (file.size > 5 * 1024 * 1024) {
      message.error(t('messages.attachmentSizeLimit'));
      return false;
    }
    const formData = new FormData();
    formData.append('file', file);
    try {
      const { response, data } = await window.apiRequest(
        `${API_BASE}/messages/attachments/upload`,
        {
          method: 'POST',
          body: formData,
        },
      );
      if (response.ok) {
        setFileList((prev) => [
          ...prev,
          { id: data.id, name: data.file_name, size: data.file_size },
        ]);
        message.success(t('messages.attachmentUploadSuccess'));
      } else {
        message.error(data.error || t('messages.attachmentUploadFailed'));
      }
    } catch (error) {
      message.error(t('messages.attachmentUploadFailed'));
    }
    return false;
  };

  const columns = [
    {
      title: t('messages.titleLabel'),
      dataIndex: 'title',
      key: 'title',
      ellipsis: true,
      render: (text, record) => {
        const isBold = !record.is_read || record.has_unread_reply;
        const isClosed = record.is_closed;
        return (
          <span
            style={{
              fontWeight: isBold ? 'bold' : 'normal',
              color: isClosed ? '#6b7280' : 'inherit',
              cursor: 'pointer',
            }}
            onClick={() => openDetail(record)}
          >
            {text}
            {record.reply_count > 0 && (
              <Text type="secondary" style={{ marginLeft: 4, fontWeight: 'normal', fontSize: 12 }}>
                ({record.reply_count})
              </Text>
            )}
          </span>
        );
      },
    },
    {
      title: t('messages.sender'),
      dataIndex: 'sender_name',
      key: 'sender_name',
      width: isMobile ? 70 : 100,
    },
    {
      title: t('messages.status'),
      key: 'status',
      width: isMobile ? 60 : 100,
      render: (_, record) => {
        if (record.is_closed) return <Tag color="default">{t('messages.statusClosed')}</Tag>;
        if (!record.is_read || record.has_unread_reply)
          return <Tag color="blue">{t('messages.statusUnread')}</Tag>;
        return <Tag color="green">{t('messages.statusRead')}</Tag>;
      },
    },
    ...(!isMobile
      ? [
          {
            title: t('messages.time'),
            dataIndex: 'created_at',
            key: 'created_at',
            width: 140,
            render: (text) => formatTime(text),
          },
        ]
      : []),
  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: (keys) => setSelectedRowKeys(keys),
  };

  const tabItems = [
    {
      key: 'feedback',
      label: (
        <Badge count={unreadCount.feedback_count} size="small" offset={[8, -2]}>
          {t('messages.feedbackTab')}
        </Badge>
      ),
    },
    {
      key: 'system',
      label: (
        <Badge count={unreadCount.system_count} size="small" offset={[8, -2]}>
          {t('messages.systemTab')}
        </Badge>
      ),
    },
  ];

  const AttachmentList = ({ attachments }) => {
    if (!attachments || attachments.length === 0) return null;
    return (
      <div className="mt-2">
        {attachments.map((att) => (
          <Tag key={att.id} icon={<PaperClipOutlined />} className="mb-1">
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                fetch(`${API_BASE}/messages/attachments/${att.id}/download`, {
                  credentials: 'same-origin',
                })
                  .then((r) => r.blob())
                  .then((blob) => {
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = att.file_name;
                    a.click();
                    URL.revokeObjectURL(url);
                  });
              }}
              className="text-primary-400 hover:text-primary-300"
            >
              {att.file_name}
            </a>
          </Tag>
        ))}
      </div>
    );
  };

  const FileUploadArea = ({ fileList, setFileList }) => (
    <div className="mt-2">
      <Upload
        beforeUpload={(file) => handleUpload(file, fileList, setFileList)}
        showUploadList={false}
        accept="*"
      >
        <ActionButton action="attachment" disabled={fileList.length >= 2}>
          {t('messages.addAttachment')} ({fileList.length}/2)
        </ActionButton>
      </Upload>
      {fileList.map((f, i) => (
        <Tag
          key={i}
          closable
          onClose={() => setFileList((prev) => prev.filter((_, idx) => idx !== i))}
          className="mt-1"
        >
          {f.name}
        </Tag>
      ))}
    </div>
  );

  return (
    <Space direction="vertical" size="large" style={{ width: '100%' }}>
      <Card
        title={
          <Space>
            <MessageOutlined />
            <span>{t('messages.title')}</span>
          </Space>
        }
        extra={
          <ActionButton
            action="send"
            variant="primary"
            iconOnly={isMobile}
            onClick={() => {
              setSendVisible(true);
              setUploadedFiles([]);
            }}
          >
            {t('messages.sendMessage')}
          </ActionButton>
        }
      >
        <Tabs
          activeKey={activeTab}
          onChange={(key) => {
            setActiveTab(key);
            setStatusFilter('');
          }}
          items={tabItems}
        />

        <Space style={{ marginBottom: 12 }} wrap>
          <Select
            placeholder={t('messages.statusFilter')}
            allowClear
            value={statusFilter || undefined}
            onChange={(v) => setStatusFilter(v || '')}
            style={{ width: 120 }}
            size={isMobile ? 'small' : 'middle'}
            options={[
              { value: 'unread', label: t('messages.statusUnread') },
              { value: 'read', label: t('messages.statusRead') },
              { value: 'closed', label: t('messages.statusClosed') },
            ]}
          />
          {selectedRowKeys.length > 0 && (
            <>
              <ActionButton action="markRead" iconOnly={isMobile} onClick={handleBatchRead}>
                {t('messages.markAsRead')} ({selectedRowKeys.length})
              </ActionButton>
              <ActionButton action="close" iconOnly={isMobile} onClick={handleBatchClose}>
                {t('messages.batchClose')} ({selectedRowKeys.length})
              </ActionButton>
            </>
          )}
          <ActionButton
            action="refresh"
            onClick={() => {
              loadMessages(currentPage, pageSize, activeTab, statusFilter);
              loadUnreadCount();
            }}
          />
        </Space>

        <Table
          rowSelection={rowSelection}
          columns={columns}
          dataSource={messages}
          rowKey="id"
          loading={loading}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: total,
            showTotal: (t_) => t('messages.total', { count: t_ }),
            showSizeChanger: !isMobile,
            onChange: (page, size) => loadMessages(page, size, activeTab, statusFilter),
          }}
          size={isMobile ? 'small' : 'middle'}
          onRow={(record) => ({
            onClick: () => openDetail(record),
            style: { cursor: 'pointer' },
          })}
        />
      </Card>

      {/* 发送新消息弹窗 */}
      <Modal
        title={t('messages.sendTitle')}
        open={sendVisible}
        onCancel={() => setSendVisible(false)}
        footer={null}
        width={isMobile ? '95%' : 600}
        destroyOnClose
      >
        <Form form={sendForm} layout="vertical" onFinish={handleSendMessage}>
          <Form.Item
            name="title"
            label={t('messages.titleLabel')}
            rules={[
              { required: true, message: t('messages.titleRequired') },
              { max: 200, message: t('messages.titleMax') },
            ]}
          >
            <Input placeholder={t('messages.titlePlaceholder')} />
          </Form.Item>
          <Form.Item
            name="content"
            label={t('messages.contentLabel')}
            rules={[{ required: true, message: t('messages.contentRequired') }]}
          >
            <TextArea rows={5} placeholder={t('messages.contentPlaceholder')} />
          </Form.Item>
          <FileUploadArea fileList={uploadedFiles} setFileList={setUploadedFiles} />
          <Form.Item style={{ marginTop: 16, marginBottom: 0, textAlign: 'right' }}>
            <Space>
              <ActionButton action="cancel" onClick={() => setSendVisible(false)} />
              <ActionButton action="send" variant="primary" htmlType="submit" loading={sendLoading}>
                {t('messages.sendMessage')}
              </ActionButton>
            </Space>
          </Form.Item>
        </Form>
      </Modal>

      {/* 消息详情弹窗 */}
      <Modal
        title={currentDetail ? currentDetail.title : t('messages.detail')}
        open={detailVisible}
        onCancel={() => setDetailVisible(false)}
        footer={null}
        width={isMobile ? '95%' : 700}
        destroyOnClose
      >
        {detailLoading ? (
          <div className="text-center py-10">{t('messages.loading')}</div>
        ) : currentDetail ? (
          <div>
            <div className="mb-4">
              <Space>
                <Tag color="blue">{currentDetail.sender_name}</Tag>
                <Text type="secondary">{formatTime(currentDetail.created_at)}</Text>
                {currentDetail.is_closed && <Tag color="default">{t('messages.statusClosed')}</Tag>}
              </Space>
              <div className="mt-3 whitespace-pre-wrap leading-relaxed">
                {currentDetail.content}
              </div>
              <AttachmentList attachments={currentDetail.attachments} />
            </div>

            {currentDetail.replies && currentDetail.replies.length > 0 && (
              <>
                <Divider style={{ margin: '12px 0' }} />
                <div className="text-xs text-dark-500 mb-2">
                  {t('messages.reply')} ({currentDetail.replies.length})
                </div>
                {currentDetail.replies.map((reply) => (
                  <div
                    key={reply.id}
                    style={{
                      padding: '10px 12px',
                      marginBottom: 8,
                      background:
                        reply.user_id === -1 ? 'rgba(234,179,8,0.1)' : 'rgba(34,197,94,0.1)',
                      borderRadius: 6,
                      border: `1px solid ${reply.user_id === -1 ? 'rgba(234,179,8,0.3)' : 'rgba(34,197,94,0.3)'}`,
                    }}
                  >
                    <Space size="small">
                      <Tag
                        color={reply.user_id === -1 ? 'orange' : 'green'}
                        style={{ fontSize: 11 }}
                      >
                        {reply.sender_name}
                      </Tag>
                      <Text type="secondary" style={{ fontSize: 12 }}>
                        {formatTime(reply.created_at)}
                      </Text>
                    </Space>
                    <div className="mt-1.5 whitespace-pre-wrap">{reply.content}</div>
                    <AttachmentList attachments={reply.attachments} />
                  </div>
                ))}
              </>
            )}

            {/* 回复输入框 */}
            {!currentDetail.is_closed && currentDetail.type !== 'system' && (
              <>
                <Divider style={{ margin: '12px 0' }} />
                <TextArea
                  rows={3}
                  placeholder={t('messages.replyPlaceholder')}
                  value={replyContent}
                  onChange={(e) => setReplyContent(e.target.value)}
                />
                <div className="flex justify-between items-start mt-2">
                  <FileUploadArea fileList={replyFiles} setFileList={setReplyFiles} />
                  <ActionButton
                    action="reply"
                    variant="primary"
                    loading={replyLoading}
                    onClick={handleReply}
                  >
                    {t('messages.reply')}
                  </ActionButton>
                </div>
              </>
            )}
          </div>
        ) : null}
      </Modal>
    </Space>
  );
}
export { MessageCenter };
